import { tw } from 'twind/css';

import { isServer } from './constants';

export const getIsMobile = () =>
  !isServer && matchMedia((tw.theme('screens.mobile') as any).raw).matches;

export const getIsDesktop = () =>
  !isServer && matchMedia((tw.theme('screens.desktop') as any).raw).matches;
